// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__tkqaz","cell":"styles_cell__3IsHc"};